"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "url(#telegramGradient) #28a9ec",
            d: "M12 3.75A8.25 8.25 0 1 0 20.25 12 8.25 8.25 0 0 0 12 3.75m3.824 5.611c-.124 1.306-.662 4.469-.935 5.931-.115.619-.343.825-.564.846-.481.044-.843-.317-1.307-.619-.726-.476-1.136-.773-1.841-1.237-.815-.537-.287-.832.178-1.314.122-.127 2.233-2.046 2.273-2.221l.004-.034a.17.17 0 0 0-.042-.111.18.18 0 0 0-.171-.016l.001-.001q-.113.024-3.482 2.299a1.56 1.56 0 0 1-.89.331h-.004a6 6 0 0 1-1.323-.316l.041.014c-.516-.168-.928-.256-.894-.542q.028-.223.613-.456 3.607-1.571 4.813-2.072c2.291-.953 2.767-1.119 3.077-1.124h.013a.54.54 0 0 1 .309.097l-.001-.002a.34.34 0 0 1 .117.222v.002a1.4 1.4 0 0 1 .013.33v-.005z"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "telegramGradient",
                    x1: ".012",
                    x2: ".012",
                    y1: "24",
                    y2: "23.976",
                    gradientTransform: "matrix(1000 0 0 -1000 0 24000)",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: "0",
                            stopColor: "#2aabee"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#229ed9"
                        })
                    ]
                })
            })
        })
    ]
}), 'Telegram'); //# sourceMappingURL=index.js.map
